import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/components/feature/HeroSection';
import CategorySection from '@/components/feature/CategorySection';
import BenefitsSection from '@/components/feature/BenefitsSection';
import ProductSection from '@/components/feature/ProductSection';
import AboutSection from '@/components/feature/AboutSection';
import ComparisonSection from '@/components/feature/ComparisonSection';
import TestimonialSection from '@/components/feature/TestimonialSection';
import ArticlesSection from '@/components/feature/ArticlesSection';
import FAQSection from '@/components/feature/FAQSection';
import CTASection from '@/components/feature/CTASection';
import Footer from '@/components/feature/Footer';
import { faqItems } from '@/mocks/content';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssbuy.info';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <BenefitsSection />
      <ProductSection />
      <AboutSection />
      <ComparisonSection />
      <TestimonialSection />
      <ArticlesSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}